<div
  class="fixed top-0 left-0 z-50 min-h-screen min-w-screen bg-zinc-800/20 backdrop-blur-xs">
  <div
    class="fixed top-2 left-1/2 h-11/12 w-11/12 -translate-x-1/2 rounded-xl bg-zinc-100 shadow-md sm:h-4/6 sm:w-5/6 dark:bg-zinc-900"
    (appClickOutside)="closePopup.emit()"
    appClickOutside>
    <div class="h-12 w-full p-3">
      <div class="relative w-full">
        <!-- Icon -->
        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <i [class]="searchIcon" class="text-zinc-500"></i>
        </div>

        <!-- Input -->
        <input
          #searchInput
          [formControl]="searchControl"
          type="text"
          role="searchbox"
          aria-label="Search"
          aria-expanded="true"
          aria-haspopup="listbox"
          [placeholder]="searchPlaceholder()"
          class="border-default bg-elevated focus:ring-accent-focus w-full rounded-md border py-2 pr-3 pl-10 text-sm text-zinc-900 placeholder:text-zinc-400 focus:ring-2 focus:outline-none dark:text-white dark:placeholder:text-zinc-500" />
      </div>
    </div>
    <div class="mt-2 w-full border-b-1 border-zinc-600"></div>
    <div role="listbox" aria-label="Search results">
      <div class="max-h-96 overflow-y-auto p-3">
        @if (isLoading()) {
          <div class="flex items-center justify-center py-8">
            <app-spinner></app-spinner>
          </div>
        } @else if (searchResults().length > 0) {
          @for (result of searchResults(); track result.id) {
            <div
              class="cursor-pointer rounded p-2 hover:bg-zinc-100 dark:hover:bg-zinc-800">
              {{ result.title }}
            </div>
          }
        } @else if (searchControl.value) {
          <div class="py-8 text-center text-zinc-500">No results found</div>
        }
      </div>
    </div>
  </div>
</div>
